import React from "react";
import { spacing } from "../../../../../../../../stitches.config";
import { Label } from "../../../../../../../Inputs";
import { FieldWrapper } from "../../__styles__/SidebarColumn";
import {
  HelpText,
  WidgetSettingsContainer,
} from "../__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "../FieldSettingsView";
import { DefaultValuesSection } from "../shared/DefaultValuesSection";
import { DisplaySettings } from "../shared/DisplaySettings";
import { FieldPermissionsConfig } from "../shared/FieldPermissionsConfig";
import { FieldSettingsConfig } from "../shared/FieldSettingsConfig";
import { HelperTextInput } from "../shared/HelperTextInput";
import { NumberDynamicDefaultInput } from "../shared/NumberDynamicDefaultInput";
import { MinMaxInputs } from "../shared/NumberMinMaxInputs";
import { NumberStaticDefaultInput } from "../shared/NumberStaticDefaultInput";
import { UnitsOptionsInput } from "./UnitsOptionsInput";
import { UnitsStaticDefaultInput } from "./UnitsStaticDefaultInput";
import { useOnRequiredChange } from "./useOnRequiredChange";

export function NumberWithUnitsFieldSettings({
  fieldPath,
  isReadOnly,
  isModuleInput,
}: InputSettingsFormProps) {
  const onRequiredChange = useOnRequiredChange(fieldPath);

  return (
    <WidgetSettingsContainer>
      <FieldSettingsConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isReadOnly={isReadOnly}
        isFormulaField={false}
        onRequiredChange={onRequiredChange}
      />
      <HelperTextInput fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <MinMaxInputs fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <div>
        <div>
          <Label
            text="Units options"
            required
            css={{ marginBottom: spacing.xs }}
          />
          <HelpText style={{ marginTop: 0, paddingBottom: spacing.s.value }}>
            Labels are visible to users, while values are backend identifiers
            and hidden from them.
          </HelpText>
        </div>
        <UnitsOptionsInput
          fieldPath={fieldPath}
          isReadOnly={isReadOnly}
          isModuleInput={isModuleInput}
        />
      </div>
      <DefaultValuesSection showTooltip>
        <FieldWrapper data-testid="dynamic-default-value-wrapper">
          <NumberDynamicDefaultInput
            fieldPath={fieldPath}
            isReadOnly={isReadOnly}
          />
        </FieldWrapper>
        <FieldWrapper data-testid="static-default-value-wrapper">
          <NumberStaticDefaultInput
            fieldPath={fieldPath}
            isReadOnly={isReadOnly}
          />
        </FieldWrapper>
        <FieldWrapper data-testid="units-static-default-value-wrapper">
          <UnitsStaticDefaultInput
            fieldPath={fieldPath}
            isReadOnly={isReadOnly}
          />
        </FieldWrapper>
      </DefaultValuesSection>
      <FieldPermissionsConfig fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <DisplaySettings
        fieldPath={fieldPath}
        isReadOnly={isReadOnly}
        isNestedField
      />
    </WidgetSettingsContainer>
  );
}
